import api from "../api/axiosClient";

const BASE = "/ArtistType";

export const getArtistTypes = async () => {
  const res = await api.get(BASE);
  return res.data;
};

export const createArtistType = async (artistTypeName: string) => {
  const res = await api.post(`${BASE}/create`, { artistTypeName });
  return res.data;
};

export const updateArtistType = async (artistTypeId: number, artistTypeName: string) => {
  const res = await api.put(`${BASE}/update/${artistTypeId}`, { artistTypeName });
  return res.data;
};

export const deleteArtistType = async (artistTypeId: number) => {
  const res = await api.delete(`${BASE}/delete/${artistTypeId}`);
  return res.data;
};
